import { useEffect, useState } from "react";
import { FileWarning, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function FileViewerPage() {
    const [error, setError] = useState("");

    useEffect(() => {
        const path = new URLSearchParams(window.location.search).get("path") || "";
        const allowed = path.startsWith("/") && !path.startsWith("//");
        if (!allowed) {
            setError("This document link is invalid.");
            return;
        }
        api.get(path, { responseType: "blob" }).then((response) => {
            const url = URL.createObjectURL(response.data);
            window.location.replace(url);
        }).catch((e) => {
            setError(e?.response?.data?.detail || "This document could not be opened.");
        });
    }, []);

    return (
        <main data-testid="file-viewer-page" className="min-h-screen bg-secondary/30 flex items-center justify-center p-6">
            <div className="text-center text-phoenix-navy">
                {error ? (
                    <><FileWarning className="w-8 h-8 mx-auto mb-3 text-destructive" />
                        <p data-testid="file-viewer-error" className="text-sm font-semibold">{error}</p></>
                ) : (
                    <><Loader2 className="w-7 h-7 mx-auto mb-3 animate-spin" />
                        <p data-testid="file-viewer-loading" className="text-sm font-semibold">Opening document…</p></>
                )}
            </div>
        </main>
    );
}